<template>
    <div class="task" ref="task" v-if="has == true">
        <top title="任务书" :color="theme_color"></top>
        <van-overlay :show="show" @click="show = false">
            <div class="wrapper">
                <div class="block" @click.stop>
                    <van-field v-model="email" label="邮箱" placeholder="我们将发送PDF至您填写的邮箱" label-width="50px"></van-field>
                    <van-button round @click="sendPdf">确定发送</van-button>
                </div>
            </div>
        </van-overlay>
        <van-popup v-model="showImage" closeable style="width:90%">
            <img src="@/assets/images/cec2022/task_image.jpg" style="width:100%;display: block;">
        </van-popup>
        <div class="top-image">
            <div class="image">
                <img :src="session.background_url" v-if="session.background_url">
                <div class="down">
                    <van-button v-if="pdf_url" @click="downloadPdf" icon="down"
                        :style="{ 'color': session.schedule_font_color ? session.schedule_font_color : '', 'background-color': session.schedule_color ? session.schedule_color : '' }">链接下载</van-button>
                    <!-- <van-button @click="show = true" icon="envelop-o"
                        :style="{ 'color': session.schedule_font_color ? session.schedule_font_color : '', 'background-color': session.schedule_color ? session.schedule_color : '' }">发送邮箱</van-button> -->
                </div>

            </div>
        </div>
        <div class="name">
            <b v-if="userInfo.realname" class="name">{{ userInfo.writer_name }}</b>
        </div>
        <div class="main" v-for="(val, key) in schedule" :key="key">
            <div class="line">{{ key }}</div>
            <div class="schedule">
                <div v-for="(item, index) in val" :key="index">
                    <h3>{{ item.session_name }}</h3>
                    <div class="detail">
                        <div class="left">
                            <p v-if="item.detail_start_at">
                                {{ formatTime(item.detail_start_at) }}-{{ formatTime(item.detail_end_at) }}</p>
                            <p v-else>{{ formatTime(item.chapter_start_at) }}-{{ formatTime(item.chapter_end_at) }}</p>
                        </div>
                        <div class="right1">
                            <p><b>{{ item.chapter_name }}</b><b v-if="item.detail_name">--{{ item.detail_name }}</b></p>
                            <p>{{ item.title }}</p>
                            <p v-if="item.zoom_set">zoom会议号：{{ item.zoom_set.url }}</p>
                            <span v-if="item.zoom_set">zoom登录密码：{{ item.zoom_set.password }}</span>
                            <img src="../../../assets/images/System/up.png" @click="changeShow(key, index)"
                                v-if="showList[key][index] && item.about.length > 0">
                            <img src="../../../assets/images/System/down.png" @click="changeShow(key, index)"
                                v-else-if="item.about.length > 0">
                        </div>
                    </div>

                    <table class="more" v-if="showList[key][index] == true">
                        <tr v-for="(val, index) in item.about" :key="index">
                            <td><span class="nowrap" style="background:gray;color:white;padding:5px;">{{
                                formatTime(val.start_at) }}-{{ formatTime(val.end_at) }}</span>
                            </td>
                            <td>
                                <p style="padding-left:10px;">{{ val.name }}</p>
                                <p style="color: rgb(69, 69, 228);padding-left:10px;">
                                    <span v-for="(item, index) in val.writers" :key="index">
                                        {{ item.name }}
                                        <span v-if="item.company" style="white-space: nowrap;
                                                overflow: hidden;
                                                text-overflow: ellipsis;
                                                max-width: 200px;
                                                display: inline-block;
                                                vertical-align: bottom;">
                                            ({{ item.company }})</span><br />
                                    </span>
                                </p>
                            </td>
                        </tr>
                    </table>
                    <div class="thick-line"></div>
                </div>

            </div>
            <!-- <div class="line"></div> -->
        </div>
        <!-- <div class="tips" v-html="session.notice" v-if="session.notice">

        </div>
        <div class="bottom-qrcode">
            <div class="qrcode" v-if="session.bottom_left_code">
                <img :src="session.bottom_left_code"/>
                <p>{{session.bottom_left_code_des}}</p>
            </div>
            <div class="qrcode"  v-if="session.bottom_right_code">
                <img :src="session.bottom_right_code"/>
                <p>{{session.bottom_right_code_des}}</p>
            </div>
        </div> -->
    </div>
</template>
<script>
import { TaskBookDetail, PersoanalUserInfo, ExpertSchedule, SendEmail, taskByTime } from '../../../config/interface.js'
import Top from "../components/Top";
export default {
    components: {
        Top
    },
    data() {
        return {
            userInfo: '',  //用户信息
            session: {},
            schedule: {},
            meeting_id: this.$route.query.meeting_id ? this.$route.query.meeting_id : this.$route.query.MT_id,
            showList: [],
            email: localStorage.getItem('email'),
            show: false,
            showImage: false,
            has: false,
            theme_color: '',
            pdf_url: ''
        }
    },
    created() {
        if (this.meeting_id == 286) {
            this.showImage = true;
        }
        if (common.is_weixin()) {
            //微信端
            this.getUserInfo();
        } else {
            //非微信端
            this.userInfo = this.$store.state.userInfo;
            if (this.userInfo) {
                this.getUserInfo();
            }
            else {
                this.$router.replace({
                    path: '/vascularNews/user/login',
                    query: { url: window.location.href }
                })
            }
        }
    },
    watch: {
        showList: {
            handler: function (newVal, old) {
                //do something
                // console.log(newVal,old)
            },
            deep: true
        }
    },
    mounted() {

    },
    methods: {
        //得到用户信息
        getUserInfo() {
            const url = PersoanalUserInfo;
            let params = {};
            const method = 'POST';
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        let data = res.data;
                        localStorage.setItem('userInfo', JSON.stringify(data));
                        this.$store.dispatch('storageUserInfo', data);
                        this.userInfo = data;
                        if (this.userInfo && this.userInfo.mobile_status == 1) {
                            // this.getMeetingSchedule();
                            this.getSchedule();
                        }
                        else {
                            common.toast('未绑定手机', 1000, 'fail', () => {
                                this.$router.replace({
                                    path: '/vascularNews/user/login',
                                    query: { url: window.location.href }
                                })
                            })
                        }
                    }
                })
        },
        //获取信息
        getMeetingSchedule() {
            const url = TaskBookDetail;
            const method = 'POST'
            let params = {
                writer_id: this.userInfo.writer_id,
                meeting_id: this.$route.query.meeting_id ? this.$route.query.meeting_id : this.$route.query.MT_id
            };
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        this.has = true;
                        this.schedule = res.data['schedules'];
                        this.session = res.data.mission_set;

                        this.showList = {};
                        for (let key in this.schedule) {
                            this.showList[key] = {};
                            for (let j in this.schedule[key]) {
                                this.showList[key][j] = {};
                                let list = [];
                                for (let i in this.schedule[key][j]) {
                                    list.push(false);
                                }
                                this.showList[key][j] = list;
                            }
                        }
                        console.log(this.showList)
                    }
                    else {
                        common.toast(res && res.error_msg ? res.error_msg : "未知错误", 1000, 'fail', () => {

                        })
                    }
                })
        },
        //获取信息
        getSchedule() {
            const url = taskByTime;
            const method = 'POST'
            let params = {
                writer_id: this.userInfo.writer_id,
                meeting_id: this.$route.query.meeting_id ? this.$route.query.meeting_id : this.$route.query.MT_id
            };
            fetch(url, params, method)
                .then((res) => {
                    if (res.code == 0) {
                        this.has = true;
                        this.schedule = res.data['schedules'];
                        this.session = res.data.mission_set;
                        this.pdf_url = res.data.pdf_url;
                        console.log('theme_color', res.data.mission_set.theme_color)
                        if (res.data.mission_set.theme_color) {
                            this.theme_color = res.data.mission_set.theme_color
                            // this.theme_color='red'
                        } else {
                            this.theme_color = '#901D22'
                        }
                        this.showList = {};
                        for (let key in this.schedule) {
                            this.showList[key] = [];
                            for (let j = 0; j < this.schedule[key].length; j++) {
                                this.showList[key].push(false);
                            }
                        }
                        console.log(this.showList)
                    }
                    else {
                        common.toast(res && res.error_msg ? res.error_msg : "未知错误", 1000, 'fail', () => {
                        })
                    }
                })
        },
        sendPdf() {
            if (this.checkEmail(this.email)) {
                const url = SendEmail;
                const method = 'POST';
                localStorage.setItem('email', this.email);
                let params = {
                    meeting_id: this.$route.query.meeting_id ? this.$route.query.meeting_id : this.$route.query.MT_id,
                    email: this.email

                };
                fetch(url, params, method)
                    .then((res) => {
                        if (res.code == 0) {
                            this.show = false;
                        }
                        else {
                            common.toast(res && res.error_msg ? res.error_msg : "未知错误", 1000, 'fail', () => {
                            })
                        }
                    })

            }

        },
        downloadPdf() {

            window.location.href = this.pdf_url;
        },
        checkEmail(val) {
            // let reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); //正则表达式
            if (val === "") { //输入不能为空
                common.toast('请您填写邮箱', 1000)
                return false;
            } else {
                return true;
            }
        },
        formatTime(str) {
            if (str) {
                str = str.slice(11, 16);
            }
            return str;

        },
        changeShow(key, index) {
            let list = [];
            for (let i = 0; i < this.showList[key].length; i++) {
                if (i == index) {
                    list.push(!this.showList[key][i])
                }
                else {
                    list.push(this.showList[key][i])
                }
            }
            this.$delete(this.showList, key);
            this.$set(this.showList, key, list);
            console.log(this.showList)
        },
    }
}
</script>
<style lang="scss">
.task {
    margin: 10px;
    padding-bottom: 10px;
    background: white;
    font-family: "Microsoft YaHei", Arial, Helvetica, sans-serif, "SimSun";

    .top-image {
        width: 100%;
        padding: 0;
        margin: 0;

        img {
            width: 100%;
        }

        .image {
            position: relative;
            min-height: 60px;
            // gap: 30px;
            padding: 0 15px;
            // margin: 20px 0;

            .down {
                position: absolute;
                display: flex;
                align-items: center;
                justify-content: space-around;
                top: 20px;
                right: 0;
                width: 100%;
                // bottom: 20px;

            }

            .van-button {
                background-color: transparent;
                color: white;
                border: 0;
                height: 40px;
                border-radius: 5px;
                // margin-right: 10px;
            }
        }
    }

    .name {
        padding-left: 3px;
        background: $color-main;
        color: white;
        line-height: 20px;
        font-size: 12px;

        /deep/ b {
            font-size: 14px;
        }
    }

    .welcome {
        line-height: 24px;
        padding: 10px;

    }

    .main {
        margin-top: 20px;
        margin-bottom: 0;

        .line {
            padding-left: 3px;
            background: $color-main;
            color: white;
            line-height: 20px;
            width: 100%;
            height: 20px;
            font-size: 14px;
        }

        .thick-line {
            height: 1px;
            width: 100%;
            background: rgb(253, 219, 219);
            margin: 10px auto;
        }

        .schedule {
            background: white;
            padding: 10px;
            line-height: 24px;
            font-size: 12px;

            .detail {
                display: flex;

                .left {
                    display: inline-block;
                    width: 80px;

                    p {
                        width: 80px;
                        white-space: nowrap
                    }
                }

                .right1 {
                    margin-left: 8px;
                    width: calc(100% - 88px);

                    img {
                        float: right;
                        width: 14px;
                    }

                }
            }

            .more {
                .nowrap {
                    overflow: hidden; //超出的文本隐藏
                    text-overflow: ellipsis; //溢出用省略号显示
                    white-space: nowrap; //溢出不换行 （只显示一行）
                }

                td {
                    vertical-align: top;
                }

                text-align: left;
                margin-top:10px;
                margin-bottom:10px;
            }

        }
    }

    .tips {
        line-height: 24px;
        padding: 10px;
    }

    .bottom-qrcode {
        display: flex;
        justify-content: space-around;

        .qrcode {
            width: 40%;
            text-align: center;

            /deep/ img {
                width: 100%;
            }
        }

    }

    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .block {
        width: 80%;
        height: 120px;
        background-color: #fff;
        padding: 10px;
        text-align: center;

        p {
            font-size: 14px;
        }

        .van-field {
            border-width: 1px;
        }

        .van-button {
            text-align: center;
            background: $color-main;
            color: white;
            margin-top: 10px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/TaskBook/Task.vue